export const enumPages = {
    SIGNED_IN: 1,
    SIGNED_OUT: 2,
}